import React from "react";
import { useParams, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

// The route sits outside CompanyProtectedRoute and react-router decodes %2F in params, so an
// unchecked `/${fileName}` iframe src could become protocol-relative (`//evil.example/...`)
// and frame an external page inside portal chrome. Only bare PDF names served from /public
// (e.g. `newtermsandconditions.pdf`) are allowed — no slashes, backslashes or colons.
const SAFE_TERMS_FILE = /^[\w.-]+\.pdf$/i;

const termsFileSrc = (fileName: string | undefined): string | null =>
  fileName && SAFE_TERMS_FILE.test(fileName) ? `/${encodeURIComponent(fileName)}` : null;

const TermsAndConditionsViewer: React.FC = () => {
  const { fileName } = useParams<{ fileName: string }>();
  const { t } = useTranslation("DocumentsTable");
  const backLink = "/documents"; // Change this if you want a different back link

  const src = termsFileSrc(fileName);

  if (!src) {
    return (
      <div className="md:mx-16 pb-[80px] mt-20 mb-16">
        <p className="text-primary-600 dark:text-primary-100 mb-6">{t("fileNotFound")}</p>
        <NavLink
          to={backLink}
          className="px-[1.25rem] py-[0.53rem] bg-primary-600 dark:bg-primary-600 text-sm text-white rounded-3xl hover:bg-primary-700 dark:hover:bg-primary-700 font-semibold "
        >
          {t("goBack")}
        </NavLink>
      </div>
    );
  }

  return (
    <div className="md:mx-16 pb-[80px] mt-20 mb-16">
      <h2 className="text-primary-600 dark:text-white lg:text-[1.875rem] font-semibold mb-16">
        Wijziging contractformule
      </h2>
      <p className="text-primary-400 text-sm font-semibold">{fileName}</p>
      <div className="mt-8 mb-8">
        <NavLink
          to={backLink}
          className="px-[1.25rem] py-[0.53rem] bg-primary-600 dark:bg-primary-600 text-sm text-white rounded-3xl hover:bg-primary-700 dark:hover:bg-primary-700 font-semibold "
        >
          {t("goBack")}
        </NavLink>
      </div>
      <iframe
        src={src}
        width="100%"
        height="700px"
        title={t("termsAndConditions") || "Terms and Conditions"}
        className="border-0"
      />
    </div>
  );
};

export default TermsAndConditionsViewer;
